import { FC } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { RouterProvider } from 'react-router-dom';

import { ApiProvider } from '@contexts/ApiProvider';
import { recoveryCollectiveTheme } from '@themes/recovery-collective-theme';

import { router } from './AppRouter';

const App: FC = () => {
  return (
    <ApiProvider>
      <ThemeProvider theme={recoveryCollectiveTheme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </ApiProvider>
  );
};

export { App };
